import React, { Suspense } from "react";
import "./index.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { VisionStudioModal, VisionStudioLayout } from "./components";
import { DrawerProvider } from "./components/VisionStudioDrawer/DrawerContext";
import { GlobalDrawer } from "./components/";
import { TrainProvider } from "./pages/Train/TrainContext";
import UserManagement from "./components/UserManagement/UserManagement";

const HomePage = React.lazy(() => import("./pages/Home"));
const Project = React.lazy(() => import("./pages/Project"));
const UploadPage = React.lazy(() => import("./pages/Upload"));

const LoginPage = React.lazy(() => import("./pages/Login"));
const RegisterPage = React.lazy(() => import("./pages/Register"));
const ForgotPasswordPage = React.lazy(() => import("./pages/ForgotPassword"));
const ResetPasswordPage = React.lazy(() => import("./pages/ResetPassword"));
const ModelPage = React.lazy(() => import("./pages/Model"));
const DataSetPage = React.lazy(() => import("./pages/Dataset"));
const RedirectPage = React.lazy(() => import("./pages/RedirectPage"));
const PlansPage = React.lazy(
  () => import("./components/VisionStudioPlans/index")
);
// const Settings = React.lazy(() => import("./pages/Settings"));

const AppRoutes: React.FC = () => {
  return (
    <>
      <Router>
        <DrawerProvider>
          <GlobalDrawer />
          <Suspense fallback={<></>}>
            <Routes>
              <Route path="/Login" element={<LoginPage />} />
              <Route path="/auth" element={<Navigate to="/Login" replace />} />
              <Route path="/ForgotPassword" element={<ForgotPasswordPage />} />
              <Route path="/ResetPassword" element={<ResetPasswordPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/" element={<RedirectPage />} />
              <Route path="/myplan" element={<PlansPage />} />
              {/* <Route path="/" element={<Navigate to="/Login" />} /> */}
              <Route
                path="/dashboard"
                element={
                  <VisionStudioLayout>
                    <HomePage />
                  </VisionStudioLayout>
                }
              />
              <Route
                path="/projects"
                element={
                  <VisionStudioLayout>
                    <VisionStudioModal />
                    <Project />
                  </VisionStudioLayout>
                }
              />
              <Route
                path="/project/:id"
                element={
                  <VisionStudioLayout>
                    <TrainProvider>
                      <VisionStudioModal />
                      <UploadPage />
                    </TrainProvider>
                  </VisionStudioLayout>
                }
              />
              <Route
                path="/models/"
                element={
                  <VisionStudioLayout>
                    <ModelPage />
                  </VisionStudioLayout>
                }
              />
              <Route
                path="/user-management/"
                element={
                  <VisionStudioLayout>
                    <UserManagement />
                  </VisionStudioLayout>
                }
              />
              <Route
                path="/dataset"
                element={
                  <VisionStudioLayout>
                    <DataSetPage />
                  </VisionStudioLayout>
                }
              />
              {/* <Route
                path="/setting"
                element={
                  <VisionStudioLayout>
                    <Settings />
                  </VisionStudioLayout>
                }
              /> */}
            </Routes>
          </Suspense>
        </DrawerProvider>
      </Router>
    </>
  );
};

export default AppRoutes;
